import RoutesMap from '../../route_control/RouteControl.js'
import {
    AssignmentList,
    AddAssignment,
    UpdateAssignment
} from "../../pages/assignment"

export const AssignmentImport = {
    RoutesMap,
    AssignmentList,
    AddAssignment,
    UpdateAssignment
}

export default AssignmentImport;
